import {GET_MINI_CART_COUNT_ACTION_BEGIN, GET_MINI_CART_COUNT_ACTION_SUCCESS, GET_MINI_CART_COUNT_ACTION_FAIL , SUCCESS} from './types';
import Helper from '../components/Helper';


export const miniCartItemCountAction = (actionUrl) => dispatch => {
    const dispatcher=dispatch;
    Helper.customFetch(actionUrl,false,GET_MINI_CART_COUNT_ACTION_BEGIN,GET_MINI_CART_COUNT_ACTION_SUCCESS,GET_MINI_CART_COUNT_ACTION_FAIL,dispatcher);
}
